import React from 'react'
import { useTranslation } from 'react-i18next'

import { BackButton } from '../../../App/Components'
import { useHistory } from '../../../Router'
import { ServiceTitle } from '../../style'
import { AddCustomerButton } from '../AddCustomerButton/AddCustomerButton'
import { CustomerAppointmentList } from '../CustomerAppointmentList/CustomerAppointmentList'

import { isPreviewDeposit } from '../../../App/Util/isDepositCheck/isPreviewDeposit'
import { ISettingsState } from '../../../Settings/Store/ISettingsState'
import { useAppSelector } from '../../../store/hooks'
import { TotalPrice } from '../TotalPrice/TotalPrice'
import { usePricePreview } from '../../../PunchCard/usePricePreview'
import { PricePreviewProvider } from '../../../PunchCard/PricePreviewContext'

type Props = {
  establishmentId: string
  settingsState: ISettingsState
}

export const OverviewHeader = ({
  settingsState,
  establishmentId,
}: Props) => {
  const { t } = useTranslation()
  const history = useHistory()

  const { customers, customerPunchCardUuids } = useAppSelector((state) => ({
    customers: state.appointment.customers,
    customerPunchCardUuids: state.appointment.customerPunchCardUuids,
  }))
  const settings = settingsState.values
  const isShowPrice = settings.showPrice

  const preview = usePricePreview(
    settings.uuid,
    establishmentId,
    customers,
    undefined,
    customerPunchCardUuids,
  )

  const totalPrice = preview.totalPrice
  const totalDeposit = preview.totalDeposit
  const isDeposit = isPreviewDeposit(settingsState, preview.totalDeposit)

  // TODO prevPath does not work, fix tis after migration of react router @help
  const prevPath: string = history.location.state
    ? history.location.state.prevPath
    : ''
  // TODO possible breaking logic when changing router
  const selectPersonPath = `/${establishmentId}/select-person`

  return (
    <PricePreviewProvider value={preview.priceInfo}>
      <ServiceTitle fontcolor={settings.fontColor}>
        {t('Services')}
      </ServiceTitle>
      <BackButton
        goBack={prevPath.includes(selectPersonPath) ? -2 : -1}
        isAppointment
      />
      <CustomerAppointmentList />
      <AddCustomerButton
        isMultipleCustomer={settings.isMultipleCustomersEnabled}
      />
      <TotalPrice
        totalPrice={totalPrice}
        isShowPrice={isShowPrice}
        totalDeposit={totalDeposit}
        isShowDeposit={isDeposit}
      />
    </PricePreviewProvider>
  )
}
